import React from 'react';
import { matchPath } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

const DEFAULT_KEY = 'default';

const getKeyByPath = (routes, path) => {
  const formattedRoutes = Object.entries(routes);
  const matchedRoute = formattedRoutes.find((route) => {
    const routeValue = route[1];
    return matchPath({ path: routeValue }, path);
  });

  if (matchedRoute) {
    return matchedRoute[0];
  } else {
    return DEFAULT_KEY;
  }
};

const getTitleTags = (subTitleData, pathKey) => {
  return [
    <title key={`title-${pathKey}`}>{subTitleData}</title>,
    <meta property={`og:title`} content={subTitleData} key={`meta-property-title-${pathKey}`} />,
  ];
};

const getMetaTags = (subDescriptionData, pathKey) => {
  return [
    <meta name="description" content={subDescriptionData} key={`meta-name-description-${pathKey}`} />,
    <meta property={`og:description`} content={subDescriptionData} key={`meta-property-description-${pathKey}`} />,
  ];
};

const getSubtitle = (pageMeta, pathKey) => {
  const defaultTitle = pageMeta.title;
  const allRoutes = pageMeta.routes;
  const routeTitle = allRoutes[pathKey]?.title || defaultTitle;
  return routeTitle;
};

const getDescription = (pageMeta, pathKey) => pageMeta.subDescription[pathKey] || pageMeta.description;

/**
 * Renders a Helmet component when any config for the path is exists in a config
 * @param { object } routes
 * @param { object } pageMeta
 * @param { string } path from location pathname
 * @returns {*}
 * @constructor
 */
export const DocHeadComponent = ({ routes, pageMeta, path = '' }) => {
  const pathKey = getKeyByPath(routes, path);
  const subTitleData = getSubtitle(pageMeta, pathKey);
  const subDescriptionData = getDescription(pageMeta, pathKey);
  const canonicalUrlData = pageMeta && pageMeta.og && pageMeta.og.url;

  if (subTitleData || subDescriptionData || canonicalUrlData) {
    return (
      <Helmet>
        {subTitleData && getTitleTags(subTitleData, pathKey).map((tag) => tag)}
        {subDescriptionData && getMetaTags(subDescriptionData, pathKey).map((tag) => tag)}
        {canonicalUrlData && <link rel="canonical" href={canonicalUrlData} key={`canonical-url-${pathKey}`} />}
      </Helmet>
    );
  }
  return null;
};

export const DocHead = connect(({ appConfig: { routes, pageMeta } }) => ({
  routes,
  pageMeta,
}))(DocHeadComponent);
